import { scratchpad } from '../components/Scratchpad/duck'
import languages from '../components/LanguageSelectorTab/duck'
import lineReader from '../components/LineReader/duck'

export default {
  scratchpad,
  languages,
  lineReader,
}
